export class InsufficientBalanceError extends Error {
  constructor() {
    super("Insufficient processing balance");
    this.name = "InsufficientBalanceError";
  }
}
